import { EHR_SERVICE_DOMAIN } from "../environments/environment";

import { isDevEnv } from "./getEnvironment";

export const createServiceBaseUrl = (region?: string | null) => {
  if (!region && isDevEnv()) {
    return `https://${EHR_SERVICE_DOMAIN}`;
  } else if (!region) {
    return `https://${EHR_SERVICE_DOMAIN}.com`;
  } else {
    return `https://${region.trim()}-${EHR_SERVICE_DOMAIN}.com`;
  }
};
